import React from 'react'
import { useSelector } from 'react-redux';
import ProgressComp from '../../Components/Progress/ProgressComp';
import { filterByIncludes } from '../../Helpers/helpers';
import { aggregatedGraphs } from '../../Utils/constants';


function AggregatedEfficiency() {

    const machines = filterByIncludes(useSelector(state => state?.kpis.stats), '_Machine')
    return (
        <div>
            <div className='boxBg boxBorderRad boxBorder p10'>
                <h3 className='cardHead pb10'>{aggregatedGraphs.map((data) => data.head)}</h3>
                <div className='dflex flexColumn gap10'>
                    {
                        machines?.map((item, index) => (
                            <ProgressComp key={index} percent={Math.round(item[Object.keys(item)[0]]).toFixed(2)} text={Object.keys(item)[0]} />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default AggregatedEfficiency